import { AkamaiCookie } from './constants';
export const detectDevice = cookies => {
  try {
    let kbbAkaData = null;
    if (cookies) {
      kbbAkaData = cookies.get ? cookies.get(AkamaiCookie) : cookies[AkamaiCookie];
      if (kbbAkaData) {
        return parseKbbAkaData(kbbAkaData);
      } else {
        console.log(`Device-api: x-kbb-aka-data NOT FOUND in cookie or header`);
      }
    }
  } catch (e) {
    console.log(e);
  }
  return null;
};
export const parseKbbAkaData = kbbAkaData => {
  if (!kbbAkaData) {
    return null;
  }
  const values = kbbAkaData.split('|'),
    isTablet = values[6] === '1',
    isMobile = values[7] === '1',
    isSmartPhone = isMobile && !isTablet,
    isDesktop = !isMobile && !isTablet,
    height = parseInt(values[8]) || 0,
    width = parseInt(values[9]) || 0,
    os = values[10] || '',
    browserName = values[11] || '';
  return {
    device: isSmartPhone ? 'mobile phone' : isTablet ? 'tablet' : 'desktop',
    istablet: isTablet,
    issmartphone: isSmartPhone,
    isdesktop: isDesktop,
    experience: 'browser',
    name: isSmartPhone ? 'phone' : isTablet ? 'tablet' : 'unk',
    os: os,
    width: width,
    height: height,
    model: `${browserName} - ${os}`
  };
};